// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"597":"f3417a44","640":"53de09ae","711":"e2522ce8","825":"4508b411"}[chunkId] + ".css";
};